import { FC } from 'react';
import styled, { css } from 'styled-components';

const asManyHourglassesAsLonger: (timeToRead: string) => string = (timeToRead) => {
  const HOURGLASS_MINUTES_THRESHOLD = 10;
  const numericTimeToRead = parseInt(timeToRead, 10);
  const numberOfHourglasses = Math.ceil(numericTimeToRead / HOURGLASS_MINUTES_THRESHOLD);
  return new Array(numberOfHourglasses).fill('⏱️').join('');
};

interface DateAndReadingTimeProps {
  date: string;
  timeToRead: string;
  marginBottom?: boolean;
}

interface TimeProps {
  $marginBottom?: boolean;
}

const Time = styled.time<TimeProps>`
  display: block;
  color: ${({ theme }): string => theme.commons.colors.gray400};
  font-size: ${(props): string => props.theme.commons.font.sizes.base};
  line-height: 1.5;

  ${(props) => css`
    ${({ theme }): string =>
      props.$marginBottom ? theme.mixins.margin({ bottom: 1.5 }) : theme.mixins.margin({ bottom: 0 })};
  `}
`;

export const DateReadingTime: FC<DateAndReadingTimeProps> = ({ date, timeToRead, marginBottom }) => (
  <Time
    $marginBottom={marginBottom}
  >{`${date} - ${asManyHourglassesAsLonger(timeToRead)} ${timeToRead} min read`}</Time>
);
